"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactRedux = require("react-redux");

var Connect = function Connect(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$mapStateToPr = options.mapStateToProps,
      mapStateToProps = _options$mapStateToPr === void 0 ? null : _options$mapStateToPr,
      _options$mapDispatchT = options.mapDispatchToProps,
      mapDispatchToProps = _options$mapDispatchT === void 0 ? null : _options$mapDispatchT;
  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Component);
};

var _default = Connect;
exports["default"] = _default;